const MainAbout = () => {
    return (
        <div class="site-section"  data-aos="fade">
            <div class="container-fluid">
                <div class="row mb-5">
                    <div class="col-md-7">
                        <img src="images/1003342_10201313423613229_266267198_n_10201313423613229.jpg" alt="Images" class="img-fluid"/>
                    </div>
                    <div class="col-md-4 ml-auto">
                        <h3 class="text-white">My Mission</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Possimus vel tenetur explicabo necessitatibus, ad soluta consectetur illo qui voluptatem. Quis soluta maiores eum. Iste modi voluptatum in repudiandae fugiat suscipit dolorum harum, porro voluptate quis? Alias repudiandae dicta doloremque voluptates soluta repellendus, unde laborum quo nam, ullam facere voluptatem similique.</p>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolor architecto excepturi aliquid minus nostrum dicta labore iusto obcaecati fugit cupiditate.</p>
                    </div>
                </div>
                <div class="row site-section">
                    <div class="col-md-6 col-lg-6 col-xl-4 text-center mb-5">
                        <img src="images/59135_10201313423053215_1482080284_n_10201313423053215.jpg" alt="Image" class="img-fluid w-50 rounded-circle mb-4"/>
                            <h2 class="text-black font-weight-light mb-4">Nik Drosakis</h2>
                            <p class="mb-4">Actor, Film-maker, Web Developer</p>
                            <p>
                                <a href="https://twitter.com/NikosDrosakis" class="pl-0 pr-3"><span class="icon-twitter"></span></a>
                                <a href="https://www.instagram.com/NikDrosakis" class="pl-3 pr-3"><span class="icon-instagram"></span></a>
                                <a href="https://www.facebook.com/nikdrosakis" class="pl-3 pr-3"><span class="icon-facebook"></span></a>
                            </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MainAbout;